import { render, staticRenderFns } from "./EditTda.vue?vue&type=template&id=34eda5cf&scoped=true&"
import script from "./EditTda.vue?vue&type=script&lang=js&"
export * from "./EditTda.vue?vue&type=script&lang=js&"
import style0 from "./EditTda.vue?vue&type=style&index=0&id=34eda5cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eda5cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
